const linkToTop = document.querySelector('.link-jump-to-top')
const scrollToTop = () => {
	if (linkToTop) {
		window.addEventListener('scroll', (e) => {
			linkToTop.style.display = window.scrollY > 250 ? 'block' : 'none'
		})
	}
}

export default scrollToTop
